import React, { Component, Fragment } from "react";
import { Label } from "@availity/form";
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Col, Row, Button } from "reactstrap";
import moment from "moment";

import awardeestore from '../stores/awardeestore';
import AllAcknowledgements from "../Acknowledgements/AllAcknowledgements";

@observer
export default class ReviewSubmitContent extends Component {

    getRowInformation = (rowData, columnSize="4") => {
        const keyVal=crypto.randomUUID();
        return (
            <Fragment key={keyVal}>
                {
                    rowData.map((row, index) => {
                        return (<Row key={`${keyVal}-${index}`} className="mt-3 mb-5">
                            {
                                Object.keys(row).map((key, keyIndex) => {

                                    return(
                                        <Col key={`${keyVal}-${index}-${keyIndex}`} sm={columnSize}>          
                                            <Label className="label-font label-font-sub" htmlFor={key.replace(' ', '')}>
                                                <b>{key}</b>
                                            </Label>
                                            <p name={key.replace(' ', '')} className="label-font label-font-sub">
                                                {row[key]}
                                            </p>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                        )
                    })
                }
            </Fragment>
        );
    }

    getRowInformationWithHtmlText = (rowData, columnSize="4") => {
        const keyVal=crypto.randomUUID();
        return (
            <Row key={`${keyVal}`} className="mt-3 mb-5">
                {
                    rowData.map((row, index) => {
                        return (      
                                <Col key={`${keyVal}-${index}`} sm={columnSize}>          
                                    <Label className="label-font label-font-sub">
                                        <b>{row.label}</b>
                                    </Label>
                                    <p className="label-font label-font-sub">
                                        {row.value}
                                    </p>
                                </Col>
                            
                        )
                    })
                }
            </Row>
        );
    }

    formatPhoneNumber = (number) => {
        if(number && number.length === 10) {
            return number.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
        return number;
    }

    formatDate(value) {
        return value ? moment(value).format("MM-DD-YYYY") : "";
    }

    render() {
        const{providerInformation, awardeeInformation, housingInfo, additionalInfo, acknowledgementInfo, awardeeMonthlyGross, incomeSourceData, 
            aShortTermRental, aMiscExpenses, awardeeMiscExpenseList, aOtherHousingAssist, housingDescription, documentUploadDetails} = awardeestore;
        const sourceAmount = incomeSourceData ? incomeSourceData.map((cat, i) => `${cat.source} - $${cat.amount}`).join(", ") : '';

        const providerAgencyName = awardeestore.getProvAgencyName(providerInformation);
        return(
            <div id="reviewAndSubmitContent">
                <h2 className="poppinsH2">
                    Review & Submit
                </h2>
                <div className='spacer-28' />
                <div className="editFromRevndSub">
                    <h4 className="poppinsH5 mb-25">Provider & Awardee Information</h4>
                    <h5 className="fs-22">Provider Information</h5>
                    {
                        this.getRowInformation([
                            {'Provider Agency Name': providerAgencyName, 'Provider Contact First Name': providerInformation.contactFirst, 'Provider Contact Last Name': providerInformation.contactLast},
                            {'Provider Contact Email': providerInformation.contactEmail, 'Provider Contact Phone': this.formatPhoneNumber(providerInformation.contactPhone)}
                        ])
                    }
                    <h5 className="fs-22 mt-4">Awardee Information</h5>
                    {
                        this.getRowInformation([
                            {'First Name': awardeeInformation.awardeeFirst, 'Last Name': awardeeInformation.awardeeLast, 'Preferred Name': awardeeInformation.awardeePreferredName},
                            {'Date of BIrth': this.formatDate(awardeeInformation.awardeeDOB), 'ProviderOne ID': awardeeInformation.awardeeProvOneId ? `${awardeeInformation.awardeeProvOneId}WA` : '' , 'Phone Number': this.formatPhoneNumber(awardeeInformation.awardeePhone)},
                            {'Phone Number Type': awardeeInformation.awardeePhoneType, 'Mailing Address': awardeeInformation.awardeeMailingAddr, 'City': awardeeInformation.awardeeCity},
                            {'State': awardeeInformation.awardeeState, 'Zip': awardeeInformation.awardeeZip, 'County': awardeeInformation.awardeeCounty},
                            {'Monthly Gross Income': awardeeMonthlyGross, 'Income Source': sourceAmount}
                        ])
                    }
                    {
                        this.getRowInformation([
                            {'Is the awardee utilizing a time-limited short-term rental resource to cover any costs?*': aShortTermRental, ...(aShortTermRental && aShortTermRental === 'Yes' ? {'Select Program': awardeeInformation.awardeeRentalAssistanceProgram, 'Start Date': this.formatDate(awardeeInformation.awardeRentalAssisProgramStartDate)}: {})},
                        ])
                    }
                    {aShortTermRental && aShortTermRental === 'Yes' &&
                        <>
                            {
                                this.getRowInformation([
                                    {'End Date': this.formatDate(awardeeInformation.awardeRentalAssisProgramEndDate), 'Amount': awardeeInformation.awardeRentalAssisProgramAmount}
                                ])
                            }
                            {
                                this.getRowInformation([
                                    {'Notes': awardeeInformation.awardeRentalAssisProgramNotes}
                                ], "12")
                            }
                        </>
                    }
                    {
                        this.getRowInformation([
                            {'Does the awardee have any miscellaneous expenses?*': aMiscExpenses}
                        ])
                    }
                    {aMiscExpenses && aMiscExpenses !== 'No' &&
                        <>
                            {
                                this.getRowInformation(
                                    awardeeMiscExpenseList.map(s => {return {'Miscellaneous expense type': s.expType, 'Amount': s.amount}}, "4")
                                )
                            }
                        </>
                    }
                    {
                        this.getRowInformation([{'Is the awardee receiving any other housing assistance?*': aOtherHousingAssist}])
                    }
                    {aOtherHousingAssist && aOtherHousingAssist === "Yes" &&
                        <>
                            {
                                this.getRowInformation([{'Please Describe': housingDescription}], "12")
                            }
                        </>
                    }
                    {this.props.onClickEditBtn && <Button className="editFromRevndSubChild" color='link' name="providerinfo" onClick={this.props.onClickEditBtn}>Edit</Button>}
                </div>

                <hr className="mtb-35 mb-10" />
                <div className="editFromRevndSub">
                    <h4 className="poppinsH5 mb-25">Housing Profile</h4>
                    {
                        <>
                            {
                                this.getRowInformation([
                                    {'In which county would you like to live?': housingInfo.county, 'Do you use:': housingInfo.walkerAndWheelChair.join(', '), 'Select Type:': housingInfo.wheelchairType},
                                    {'Width': housingInfo.wheelchairWidth ? housingInfo.wheelchairWidth.replace(" inches", "\"") : "", 'Do you know if you will need to request reasonable modifications and/or accommodations once you obtain housing due to a disability?*': housingInfo.modifications},
                                ])
                            }
                            {housingInfo.modifications === 'Yes' &&
                                this.getRowInformation([
                                    {'What reasonable accommodations and/or modifications are needed?': housingInfo.reasonableAccommodations}
                                ], "12")
                            }
                            {
                                this.getRowInformationWithHtmlText([
                                    
                                        {label: 'What size unit is needed?', value: housingInfo.unitSize}, 
                                        {label: <>Other than the head of household, are there any other adults (age 18+) in your &nbsp;&nbsp; household?*</>, value: housingInfo.otherHouseHoldPerson}, 
                                        {label: 'How many people will be living with you?*', value: housingInfo.peopleLiving}
                                    
                                ])
                            }
                            {
                                housingInfo.peopleLivingDetails.map(peopleLivingDetail => {
                                    return this.getRowInformation([{'First Name': peopleLivingDetail.firstName, 'Last Name': peopleLivingDetail.lastName, 'Age': peopleLivingDetail.age},
                                        {'Relationship': peopleLivingDetail.relationship}
                                    ])
                                })
                            }
                            {
                                this.getRowInformation([{
                                    'Do you have any other housing preferences, needs, and/or limitations that will help with housing identification?': housingInfo.otherPreferences
                                }], "12")
                            }
                        </>
                    }
                    {this.props.onClickEditBtn && <Button className="editFromRevndSubChild" color='link' name="housingprofile" onClick={this.props.onClickEditBtn}>Edit</Button>}
                </div>

                <hr className="mtb-35" />
                <div className="editFromRevndSub">
                    <h4 className="poppinsH5 mb-25">Additional Questions</h4>
                    {
                        this.getRowInformation([{'Do you need short-term rental assistance to cover move-in costs and/or other costs as you work with your case manager to identify and/or obtain permanent affordable housing?*': additionalInfo.shortTermRentalRadio}], "5")
                    }
                    {additionalInfo.shortTermRentalRadio === "Yes" &&
                        <>
                            {
                                this.getRowInformation([{'What costs need to be covered with other resources': additionalInfo.shortTermRentalDetails}], "12")
                            }
                        </>
                    }
                    {
                        this.getRowInformation([{'Do you have someone who helps manage your money? (i.e. a payee)?*' : additionalInfo.moneyManagerRadio,
                            'Do you know if you owe money to a former landlord or Public Housing Authority for unpaid rent or damage?*' : additionalInfo.oweMoneyRadio}
                        ])
                    }
                    {additionalInfo.oweMoneyRadio === "Yes" && this.getRowInformation([{'Please provide details': additionalInfo.oweMoneyDetails}], "12")}
                    {this.props.onClickEditBtn && <Button className="editFromRevndSubChild" color='link' name="additionalquestions" onClick={this.props.onClickEditBtn}>Edit</Button>}
                </div>
                <hr className="mtb-35" />
                <div className="editFromRevndSub">
                    <h4 className="poppinsH5 mb-25">Documents</h4>
                    {
                        documentUploadDetails.map(doc => (
                            doc.fileName ?
                                <div key={doc.documentName}>
                                    <Row className="mt-3 mb-5">
                                        <Col sm="6">
                                            <Label className="label-font label-font-sub">
                                                {
                                                doc.documentName === "Other" ? doc.customDocumentName : doc.documentName
                                                }
                                            </Label>
                                        </Col>
                                        <Col sm="6" >
                                            <Label className="label-font label-font-sub">
                                                {doc.fileName}
                                            </Label>
                                        </Col>
                                    </Row>
                                    {this.props.onClickEditBtn && <Button className="editFromRevndSubChild" color='link' name="documents" onClick={this.props.onClickEditBtn}>Edit</Button>}
                                </div>
                                :
                                null
                        ))
                    }
                </div>
                <hr className="mtb-35" />
                <div className="editFromRevndSub">
                    <h4 className="poppinsH5 mb-25">Acknowledgements</h4>
                    <AllAcknowledgements viewOnly/>
                    {this.getRowInformation([{'Date Consent Received': this.formatDate(acknowledgementInfo.consentDate), 'Time Consent Received': acknowledgementInfo.consentTime ? moment(acknowledgementInfo.consentTime, 'HH:mm').format('hh:mm A') : ''}])}
                    {this.props.onClickEditBtn && <Button className="editFromRevndSubChild" color='link' name="acknowledgements" onClick={this.props.onClickEditBtn}>Edit</Button>}
                </div>
            </div>
        )
    };
}

ReviewSubmitContent.defaultProps = {
    onClickEditBtn: undefined
}

ReviewSubmitContent.propTypes = {
    onClickEditBtn: PropTypes.func
}